// extracted by mini-css-extract-plugin
export default {"container_aboutuspage":"AboutUsPage_container_aboutuspage__1lmiS"};